import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const DisclosureForInvestigateConsumerReport = forwardRef(({ data, company, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div ref={refToPrint} className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">
                        FCRA - DISCLOSURE FOR INVESTIGATIVE CONSUMER REPORT
                    </h1>
                    <p className="text-base text-gray-700">
                        <span className="font-semibold">{company?.name}</span>, the “Company,” may request an investigative consumer report
                        about you from a third-party consumer reporting agency, in connection with your employment or application for employment.
                        An "investigative consumer report" is a background report that includes information from personal interviews
                        (except in California, where that term includes background reports with or without information obtained from personal interviews).
                        The most common form of an investigative consumer report in connection with your employment is a reference check through
                        personal interviews with sources such as your former employers and associates, and other information sources.
                        The investigative consumer report may contain information concerning your character, general reputation,
                        personal characteristics, mode of living, or income verification. You may request more information about
                        the nature and scope of an investigative consumer report, if any, by contacting the Company.
                    </p>
                    <div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-700 space-y-2 border border-gray-200">
                        <p>
                            If adverse action is taken resulting from information obtained, in whole or in part, from an
                            investigative consumer report from a consumer reporting agency, you will have the option to receive a copy
                            of the report from VerifiedID.
                        </p>
                        <p>
                            VerifiedID can be contacted at:
                            <br />
                            11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA
                            <br />
                            Phone: <a href="tel:+18887182597" className="text-blue-600 underline">(888) 718-2597</a>
                        </p>
                    </div>
                    <p className="text-base text-gray-700">
                        [End of FCRA - DISCLOSURE FOR INVESTIGATIVE CONSUMER REPORT]
                    </p>
                </div>
            </div>
        </div>
    )

})

export default DisclosureForInvestigateConsumerReport
